import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import { isTaskComplete } from '@sakari-io/staza-common';
import moment from 'moment';
import C3Chart from 'react-c3js';
import { Card, CardTitle, CardText } from 'material-ui/Card';
import _ from 'lodash';
import 'c3/c3.css';

import { fetchJob } from '../../../actions/jobs';
import Dashboard from '../../Dashboard';
import { sortDates } from '../../../utils/helper';
import { fetchTasksRoutine } from '../../../routines';

import styles from './styles';

// const data = {
//   data: {
//     columns: [
//       ['data', 67],
//     ],
//     type: 'gauge',
//   },
//   gauge: {},
//   color: {
//     pattern: ['#FF0000', '#F97600', '#F6C600', '#60B044'], // the three color levels for the percentage values.
//     threshold: {
// //            unit: 'value', // percentage is default
// //            max: 200, // 100 is default
//       values: [30, 60, 90, 100]
//     }
//   },
//   size: {
//     height: 180
//   },
// };

// const jobProgress = {
//   data: {
//     columns: [
//       ['data', 67]
//     ],
//     type: 'gauge',
//   },
//   gauge: {},
//   color: {
//     pattern: ['#FF0000', '#F97600', '#F6C600', '#60B044'], // the three color levels for the percentage values.
//     threshold: {
// //            unit: 'value', // percentage is default
// //            max: 200, // 100 is default
//       values: [30, 60, 90, 100]
//     }
//   },
//   size: {
//     height: 180
//   },
// };

const getLastStageCompletion = (stage = {}) => {
  if (stage.completed) {
    return _.values(stage.completed).reduce((res,completion) => {
      const at = moment(completion.at);
      if (!res) {
        return at;
      }

      if (at.isAfter(res)) {
        return at;
      }

      return res;
    }, null);
  }

  return null;
}

const getLastTaskCompletion = (task = {}) => {
  if (task && task.stages) {
    return _.values(task.stages).reduce((res,stage) => {
      const at = getLastStageCompletion(stage);
      if (!res) {
        return at;
      }

      if (at.isAfter(res)) {
        return at;
      }

      return res;
    }, null);
  }

  return null;
}

const aggregateData = (job, tasks = [], level = 'Tasks') => {
  if (!job.profile || !job.profile.stages || _.keys(job.profile.stages).length === 0) {
    return {
      types: [],
      dates: [],
    };
  }

  const typesMap = {};
  const data = tasks
    .filter((task) => isTaskComplete(task, job.profile.stages))
    .reduce((res, task) => {
      // const completed = _.values(task.stages || {})
      //   .reduce((result, stage) => {
      //     (!result || getLastCompletion(stage).isAfter(result)) ? moment(stage.completed).startOf('d') : result
      //   }, null);
      const completed = moment(getLastTaskCompletion(task)).startOf('d');
      const date = completed.toISOString();
      res[date] = _.mergeWith(res[date], _.values(task.items).reduce((res2, item) => {
        typesMap[item.type.id] = item.type;
        const typeData = res2[item.type.id] || { type: item.type, quantity: 0 };
        res2[item.type.id] = {
          type: item.type,
          quantity: typeData.quantity + 1,
        };
        return res2;
      }, {}), (a = { quantity: 0 }, b = { quantity: 0 }) => {
        return _.assign(a, b, { quantity: a.quantity + b.quantity });
      });

      return res;
    }, {});

  console.log('data1', data);

  const dates = _.keys(data).sort(sortDates);

  const result = {
    types: _.values(typesMap),
    dates,
    data,
  };

  return result;
};

class ItemBreakdownReport extends Component {
  static propTypes = {
    fetchJob: PropTypes.func.isRequired,
    job: PropTypes.object.isRequired,
    fetchTasks: PropTypes.func.isRequired,
    tasks: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    dialogs: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  };

  state = {
    data: {
      dates: [],
      types: [],
    },
  };

  componentWillMount() {
    const jobId = this.props.match.params.jobId;
    this.props.fetchJob(jobId);
    this.props.fetchTasks(jobId);
  }

  componentWillReceiveProps(nextProps) {
    const data = aggregateData(nextProps.job, _.values(nextProps.tasks));
    console.log('data', data);
    const columns = [
      ['x'].concat(data.types.map(type => type.name)),
    ].concat(data.dates.map((date) => _.flatten([moment(date).format('ll'), data.types.map(type => {
      const t = data.data[date][type.id] || {};
      return t.quantity || 0;
    })])));
    const config = {
      data: {
        x: 'x',
        columns,
        type: 'bar',
        groups: [data.dates.map(date => moment(date).format('ll'))],

      },
      bar: {
        width: {
          ratio: 0.9, // this makes bar width 50% of length between ticks
        },
      },
      axis: {
        x: {
          type: 'category',
        },
      },
    };

    console.log('config', config);

    this.setState({
      data,
      config,
    });
  }

  renderBreakdown = () => {
    const data = this.state.data;

    return (<Table multiSelectable={false} selectable={false}>
      <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
        <TableRow>
          <TableHeaderColumn>Item Type</TableHeaderColumn>
          { (data.dates || []).map((date) => <TableHeaderColumn
            key={date}>{moment(date).format('ll')}</TableHeaderColumn>)}
          <TableHeaderColumn>Total</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody displayRowCheckbox={false}>
        { this.renderItems(data) }

        <TableRow style={styles.totalRow}>
          <TableRowColumn>
            <div style={styles.total}>Total</div>
          </TableRowColumn>
          { data.dates.map((date) => <TableRowColumn key={date}>
            <div style={styles.total}>{_.values(data.data[date]).reduce((res, val) => res + val.quantity, 0)}</div>
          </TableRowColumn>)}
          <TableRowColumn>
            <div style={styles.total}>{ data.dates.reduce((res, date) =>
            res + _.values(data.data[date]).reduce((res, val) => res + val.quantity, 0), 0) }</div>
          </TableRowColumn>
        </TableRow>
      </TableBody>
    </Table>);
  };

  /*
   {{ _.keys(totals).sort().map((date) => <TableHeaderColumn key={date}>}
   // <div style={styles.total}>{totals[date]}</div>
   // </TableHeaderColumn>)}


   <div style={styles.totalColumn}>{_.values(totals).reduce((res, val) => res + val, 0)}</div>

   */

  renderItems = (data) => {
    return data.types.map(type => this.renderItem(data, type));
  };

  renderItem = (data, type) => {
    return (<TableRow key={type.id}>
      <TableRowColumn>{type.name}(s)</TableRowColumn>
      { data.dates.map((date) => {
        const t = data.data[date][type.id];
        return (<TableRowColumn key={date}>{t ? t.quantity : 0}</TableRowColumn>);
      })}
      <TableRowColumn style={styles.totalRow}>
        <div style={styles.total}>{ data.dates.reduce((res, date) => {
          const t = data.data[date][type.id];
          return res + (t ? t.quantity : 0);
        }, 0) }</div>
      </TableRowColumn>
    </TableRow>);
  };

  render() {
    const { config } = this.state;
    // TODO change customer name
    const customer = this.props.job && this.props.job.customer ? this.props.job.customer.name : 'Unknown';
    const description = this.props.job.description;
    return (
      <Dashboard title={`Item Breakdown - ${customer}`}>
        <div style={styles.summaryCharts}>
          <Card style={styles.card}>
            <CardTitle
              title={'Items by Type'}
              subtitle={description} titleColor="white"
              style={styles.blueCardTitle}
              subtitleColor="white"
            />
            <CardText>
              { this.state.config ? <C3Chart data={config.data} bar={config.bar} axis={config.axis}/> : null }
            </CardText>
          </Card>
        </div>
        <div>
          { this.renderBreakdown() }
        </div>
      </Dashboard>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchJob,
    fetchTasks: (jobId) => fetchTasksRoutine.trigger({ jobId }),
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    job: state.get('jobs').get('job').toJS(),
    tasks: state.get('tasks').get('tasks').toJS(),
    loading: state.get('jobs').get('loading'),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemBreakdownReport);



// WEBPACK FOOTER //
// ./src/components/Reports/ItemBreakdownReport/index.js